import {
  IonPage,
  IonContent,
  IonButton,
  IonIcon,
  useIonToast,
  IonActionSheet,
  isPlatform,
} from "@ionic/react";
import {
  chevronBackOutline,
} from "ionicons/icons";
import Button from "../../components/atoms/button";
import { useEffect, useState } from "react";
import {
  EditUserFunction,
  GetUserFunction,
  onFileUploadValidationSize,
} from "../../services/API";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "../../components/atoms/spinner";
import { ErrorMessage, Field, Formik } from "formik";
import {
  convertToBase64,
  presentToastFunction,
} from "../../services/genericMethoud/generice";
import { responseCodes } from "../../services/API/responseCodes";
import * as Yup from "yup";
import { setUserInfo } from "../../services/redux/actions";

const EditProfile = ({
  editProfileDismiss,
}: {
  userId: any;
  IsReport: any;
  IsLogoMessage: any;
  editProfileDismiss: (
    data?: string | null | undefined | number,
    role?: string
  ) => void;
}) => {
  const { token } = useSelector((state: any) => state.reducer);
  const { userInfo } = useSelector((state: any) => state.reducer);
  const dispatch = useDispatch();
  const setUserInfoFunction = (returnedData: Object) =>
    dispatch(setUserInfo(returnedData));
  const [selectedFile, setSelectedFile] = useState<File | any>(null);
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [userData, setUserData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  let [presentToast] = useIonToast();

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      // Validate file type (only images)
      if (!file.type.startsWith("image/")) {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          "من فضلك اختر صورة صحيحة"
        );
        return;
      }

      // Validate file size (max 3MB)
      if (file.size > 3 * 1048576) {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          `عفوا الملف ${file.name} حجم أكبر من 3 ميجا`
        );
        return;
      }

      setSelectedImage(null);
      setSelectedFile(null);
      
      const fileBase64: any = await convertToBase64(file);
      setSelectedImage(fileBase64);
      setSelectedFile(file);
    }
  };

  function getUserData() {
    GetUserFunction(userInfo.id, token)
      .then((returnedData) => {
        setIsLoading(true);
        const fetchedUserData = returnedData.data.dateSet;
        setUserData(fetchedUserData);
        console.log(returnedData);

        setSelectedImage(
          !fetchedUserData.profileImage ||
            fetchedUserData.profileImage == ""
            ? "https://cdn-icons-png.flaticon.com/512/149/149071.png"
            : fetchedUserData.profileImage
        );
        
        // Update Redux state with fresh user data
        setUserInfoFunction(fetchedUserData);
        
        // Update localStorage
        const persistantState = localStorage.getItem("persistantState");
        if (persistantState) {
          try {
            const parsedState = JSON.parse(persistantState);
            parsedState.userInfo = fetchedUserData;
            localStorage.setItem("persistantState", JSON.stringify(parsedState));
          } catch (e) {
            console.error("Error updating localStorage:", e);
          }
        }
        
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getUserData();
  }, []);

  async function editUserFunction(values: any) {
    setIsLoading(true);
    let dataToBeSent = { id: userInfo.id };
    let imageToBeSent;
    if (selectedFile) {
      let checkFileResult = await onFileUploadValidationSize(
        selectedFile,
        3 * 1048576
      );
      if (!checkFileResult) {
        presentToastFunction(
          presentToast,
          "top",
          "danger",
          ` عفوا الملف  ${selectedFile.name}  حجم اكبر من 3 ميجا`
        );
        return;
      }
      const regex = /data:.*base64,/;
      const fileWithOut = await selectedImage.replace(regex, "");
      imageToBeSent = await fileWithOut;
    }

    dataToBeSent = await { ...values, address: values.address };

    dataToBeSent = await { ...values, email: values.email };

    dataToBeSent = await { ...values, phoneNumber: values.phoneNumber };

    dataToBeSent = await { ...values, nickName: values.nickName };

    dataToBeSent = await {
      ...values,
      officePhoneNumber: values.officePhoneNumber,
    };

    dataToBeSent = await { ...values, bio: values.bio };

    console.log("dataToBeSentdataToBeSent", dataToBeSent);
    await EditUserFunction(dataToBeSent, imageToBeSent, token)
      .then(async (response: any) => {
        console.log(response.data);
        if (response.data.responseCode == responseCodes.OK) {
          presentToastFunction(
            presentToast,
            "top",
            "success",
            "تم تعديل البيانات بنجاح"
          );
          
          // Fetch updated user data and update Redux + localStorage
          await GetUserFunction(userInfo.id, token)
            .then((updatedData) => {
              const updatedUserInfo = updatedData.data.dateSet;
              
              // Update Redux state
              setUserInfoFunction(updatedUserInfo);
              
              // Update localStorage
              const persistantState = localStorage.getItem("persistantState");
              if (persistantState) {
                try {
                  const parsedState = JSON.parse(persistantState);
                  parsedState.userInfo = updatedUserInfo;
                  localStorage.setItem("persistantState", JSON.stringify(parsedState));
                  console.log("Updated userInfo in Redux and localStorage");
                } catch (e) {
                  console.error("Error updating localStorage:", e);
                }
              }
            })
            .catch((e) => {
              console.error("Error fetching updated user data:", e);
            });
        } else {
          presentToastFunction(
            presentToast,
            "top",
            "danger",
            response.data.responseMessage
          );
        }
        setIsLoading(false);
      })
      .catch((e: any) => {
        console.log(e);
        presentToastFunction(presentToast, "top", "danger", e);
        setIsLoading(false);
      });

  }

  const openFileDialog = () => {
    (document as any).getElementById("file-upload").click();
  };

  const validationSchema = () => {
    return Yup.object().shape({
      email: Yup.string()
        .email("الرجاء كتابة الإيميل بشكل صحيح")
        .nullable(true),
      phoneNumber: Yup.string()
        .required("رقم الهاتف مطلوب")
        .test(
          "no-plus-prefix",
          "رقم الهاتف لا يجب أن يبدأ بـ +",
          (value) => !value || !value.startsWith("+")
        )
        .test(
          "no-966-prefix",
          "رقم الهاتف لا يجب أن يبدأ بـ 966",
          (value) => !value || !value.startsWith("966")
        )
        .test(
          "no-zero-prefix",
          "رقم الهاتف لا يجب أن يبدأ بـ 0",
          (value) => !value || !value.startsWith("0")
        ),
      officePhoneNumber: Yup.string()
        .test(
          "no-plus-prefix",
          "رقم المكتب لا يجب أن يبدأ بـ +",
          (value) => !value || !value.startsWith("+")
        )
        .test(
          "no-966-prefix",
          "رقم المكتب لا يجب أن يبدأ بـ 966",
          (value) => !value || !value.startsWith("966")
        )
        .test(
          "no-zero-prefix",
          "رقم المكتب لا يجب أن يبدأ بـ 0",
          (value) => !value || !value.startsWith("0")
        )
        .nullable(true),
    });
  };

  const [showActionSheet, setShowActionSheet] = useState(false);

  return (
    <IonPage className="max-h-screen">
      <IonContent className="max-h-screen">
        {isLoading ? (
          <Spinner isFull={true} color={"primary"} size={"large"} />
        ) : null}
        <Formik
          initialValues={{
            id: userInfo?.id,
            fullName: userData?.fullName,
            nickName: userData?.nickName,
            userName: userData?.userName?.split(".")[0],
            address: userData?.address,
            email: userData?.email,
            phoneNumber: userData?.phoneNumber,
            officePhoneNumber: userData?.officePhoneNumber,
            bio: userData?.bio,
          }}
          enableReinitialize={true}
          validateOnBlur={true}
          validateOnChange={true}
          validationSchema={validationSchema}
          onSubmit={async (values: any, actions) => {
            await editUserFunction(values);
            setIsLoading(false);
          }}
        >
          {({ handleSubmit, dirty, isValid }) => (
            <>
              <div
                className="w-full flex flex-col justify-start items-center bg-primaryColor100 rounded-lg"
                style={{ marginBottom: "45px", height: "9em" }}
              >
                <div
                  className={`w-full grid grid-cols-3 ${
                    isPlatform("ios") && "pt-7"
                  }`}
                >
                  <div
                    className={`col-span-1 ${
                      isPlatform("ios") ? "py-6" : "py-4"
                    } px-6 flex flex-row justify-start items-center`}
                  ></div>
                  <div
                    className={`col-span-1 ${
                      isPlatform("ios") ? "py-6" : "py-4"
                    } flex flex-row justify-center items-center`}
                  >
                    <p className="font-bold text-white text-2xl whitespace-nowrap">
                      تعديل بيانات الحساب
                    </p>
                  </div>
                  <div
                    className={`col-span-1 ${
                      isPlatform("ios") ? "py-6" : "py-4"
                    } px-6 flex flex-row justify-end items-center z-50`}
                  >
                    <button
                      onClick={() => {
                        editProfileDismiss(null, "cancel");
                      }}
                      className="flex flex-col justify-center items-center"
                    >
                      <IonIcon
                        icon={chevronBackOutline}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                </div>

                <div className="profile-picture-container animate__animated animate__jackInTheBox">
                  <Field
                    type="file"
                    name="profileImage"
                    id="file-upload"
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                  <img
                    src={selectedImage}
                    style={{ filter: "blur(0.5px)", height: "6rem" }}
                    className="blur-sm size-28 group-hover:blur-0 rounded-full"
                    height={80}
                    width={80}
                    alt="الصورة الشخصية"
                    id="profile-picture"
                  />
                  <IonButton
                    className="py-3"
                    style={{
                      marginRight: "-5px",
                      paddingTop: "9px",
                      marginTop: "auto",
                    }}
                    onClick={openFileDialog}
                  >
                    رفع الصورة
                  </IonButton>
                </div>
              </div>
              <div
                className={`w-full ${
                  isPlatform("ios") ? "pt-7 mt-7" : "pt-4 mt-4"
                } mr-8 animate__animated animate__lightSpeedInRight`}
              >
                <h2 className="text-2xl">البيانات الخاصة</h2>
              </div>

              <div className="form-container">
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInRight">
                  <Field
                    disabled={true}
                    readOnly={true}
                    name="fullName"
                    type="text"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="اكتب اسم المستخدم"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-paragraphColor -translate-y-6 right-6">
                    الإسم
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInRight">
                  <Field
                    name="nickName"
                    type="text"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="اكتب كنية المستخدم"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-primaryColor100 -translate-y-6 right-6">
                    كنية المستخدم <span className="text-redColor">*</span>
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInLeft">
                  <Field
                    disabled={true}
                    readOnly={true}
                    name="userName"
                    type="text"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="اكتب رقم الهوية"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-paragraphColor -translate-y-6 right-6">
                    رقم الهوية
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInRight">
                  <Field
                    type="text"
                    name="address"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="ادخل العنوان المناسب"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-primaryColor100 -translate-y-6 right-6">
                    العنوان
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInRight">
                  <Field
                    type="email"
                    name="email"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="اكتب بريدك الإلكتروني"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-redColor text-lg"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-primaryColor100 -translate-y-6 right-6">
                    البريد الإلكتروني
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInLeft">
                  <div className="flex items-center">
                    <Field
                      type="text"
                      autoFocus={true}
                      maxLength={9}
                      name="phoneNumber"
                      className="block px-5 py-2.5 font-bold placeholder-paragraphColor flex-1 text-xl text-primaryColor100 bg-transparent rounded-l border-2 border-paragraphColor appearance-none focus:outline-none focus:ring-0 focus:border-blue-600"
                      placeholder="مثال: 534542111"
                    />
                    <div className="flex items-center px-3 py-2.5 font-bold text-xl text-slate-500 bg-slate-50 border-2 border-r-0 border-paragraphColor rounded-l" dir="ltr">
                      +966
                    </div>
                  </div>
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="text-redColor text-lg mt-1"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2 text-primaryColor100 -translate-y-6 right-6">
                    رقم الهاتف <span className="text-redColor">*</span>
                  </label>
                </div>
                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInRight">
                  <div className="flex items-center">
                    <Field
                      type="text"
                      autoFocus={true}
                      maxLength={9}
                      name="officePhoneNumber"
                      className="block px-5 py-2.5 font-bold placeholder-paragraphColor flex-1 text-xl text-primaryColor100 bg-transparent rounded-l border-2 border-paragraphColor appearance-none focus:outline-none focus:ring-0 focus:border-blue-600"
                      placeholder="مثال: 534542111"
                    />
                    <div className="flex items-center px-3 py-2.5 font-bold text-xl text-slate-500 bg-slate-50 border-2 border-r-0 border-paragraphColor rounded-l" dir="ltr">
                      +966
                    </div>
                  </div>
                  <ErrorMessage
                    name="officePhoneNumber"
                    component="div"
                    className="text-redColor text-lg mt-1"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-primaryColor100 -translate-y-6 right-6">
                    رقم المكتب
                  </label>
                </div>

                <div className="relative w-full px-4 mt-4 animate__animated animate__lightSpeedInLeft">
                  <Field
                    as="textarea"
                    name="bio"
                    className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
                    placeholder="ادخل نبذة عامة عنك"
                  />
                  <label className="absolute text-xl font-bold top-2 z-10 bg-white px-2  text-primaryColor100 -translate-y-6 right-6">
                    نبذة عامة
                  </label>
                </div>

                <div className="w-full mt-4 px-4 animate__animated animate__fadeInUp">
                  <Button
                    theme={"primary"}
                    text={"تأكيد"}
                    size={"big"}
                    disabled={(!isValid || !dirty) && !selectedFile}
                    onClick={() => setShowActionSheet(true)}
                  />
                </div>

                <div className="w-full my-4 px-4 animate__animated animate__fadeInUp">
                  <Button
                    theme={"danger"}
                    text={"إغلاق"}
                    size={"big"}
                    onClick={() => {
                      editProfileDismiss();
                    }}
                    />
                </div>
              </div>
              <IonActionSheet
                isOpen={showActionSheet}
                onDidDismiss={() => setShowActionSheet(false)}
                header="هل انت متأكد من تعديل البيانات"
                buttons={[
                  {
                    text: "نعم",
                    handler: handleSubmit,
                  },
                  {
                    text: "لا",
                    handler: () => setShowActionSheet(false),
                  },
                  {
                    text: "إلغاء",
                    role: "cancel",
                  },
                ]}
              ></IonActionSheet>
            </>
          )}
        </Formik>
      </IonContent>
    </IonPage>
  );
};

export default EditProfile;
